<template>
  <div v-if="medias" :id="carouselId" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
      <div v-for="(image, index) in medias" :key="image.id" :class="{ 'active': index === 0 }" class="carousel-item">
        <img v-if="image.media" :alt="image.media.alt" :src="widgetURL + image.media.url" class="d-block w-100">
      </div>
    </div>
    <template v-if="medias.length > 1">
      <button :data-bs-target="'#' + carouselId" class="carousel-control-prev" data-bs-slide="prev" type="button">
        <span aria-hidden="true" class="carousel-control-prev-icon"></span>
        <span class="visually-hidden">{{ catalogueTraduction?.sliderPrecedent || $t('slider.precedent') }}</span>
      </button>
      <button :data-bs-target="'#' + carouselId" class="carousel-control-next" data-bs-slide="next" type="button">
        <span aria-hidden="true" class="carousel-control-next-icon"></span>
        <span class="visually-hidden">{{ catalogueTraduction?.sliderSuivant || $t('slider.suivant') }}</span>
      </button>
    </template>
  </div>
</template>

<script>

export default {
  name: "ImageSlider",
  props: ['medias', 'type', 'catalogueTraduction'],
  setup(props) {
    const widgetURL = process.env.VUE_APP_WIDGET_API_SERVER;
    const carouselId = 'carousel-' + props.type;
    return {widgetURL, carouselId};
  }
}
</script>

<style scoped>
.carousel .carousel-item {
  height: 350px;
}

.carousel-item img {
  position: absolute;
  top: 0;
  left: 0;
  min-height: 350px;
}
</style>
